import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface ISwitchRowProps {
  hideUnderLine?: boolean;
  spaceBetween?: boolean;
}

export const SwitchRow = styled.span<ISwitchRowProps>`
  display: flex;
  justify-content: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.spaceBetween ? "space-between" : "flex-start")
  };
  align-items: center;
  padding: 9px 10px 9px 6px;
  border-bottom: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (props: any): number => (props.hideUnderLine ? 0 : 1)
    }px
    solid ${withVar(DesignToken.BorderBasicSecondary)};
`;
